import { createStore } from "vuex";
import search from "./storeModules/search"
import user from "./storeModules/user"
import job from "./storeModules/job"
export default createStore({
  modules: {
    search,
    user,
    job,
  }
});